module.exports = __webpack_public_path__ + "img/credit-mobile.cdb53068.svg";